<template>
  <div class="progress-container">
    <div class="progress">
      <div class="goal" :style="goalStyle">
        <span class="progress-value">{{ goal }}</span>
      </div>
      <div class="grade" :style="gradeStyle">
        <span class="progress-value">{{ grade }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressBar",
  props: {
    grade: {
      type: Number,
      required: true
    },
    goal: {
      type: Number,
      required: true
    },
    grade_color: {
      type: String,
      required: false,
      default: "#0f95cb"
    },
    goal_color: {
      type: String,
      required: false,
      default: "#6fbfe0"
    }
  },
  computed: {
    goalStyle() {
      return {
        width: `${10 * this.goal}%`,
        background: this.goal_color
      };
    },
    gradeStyle() {
      return {
        width: `${10 * this.grade}%`,
        background: this.grade_color
      };
    }
  }
};
</script>
<style lang="scss">
.progress-container {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  .progress {
    box-shadow: inset 0px 2px 5px rgba(64, 64, 64, 0.1);
    background: white;
    border: 0.5px solid #d9d9d9;
    box-sizing: border-box;
    border-radius: 10px;
    position: relative;
    width: inherit;
    height: 4em;

    .grade,
    .goal {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      height: 100%;
      border-radius: 10px 0px 0px 10px;

      .progress-value {
        color: white;
        font-weight: 500;
        font-size: 2em;
        line-height: 2em;
        position: relative;
        float: right;
        right: 0.5em;
      }
    }
  }
}
</style>
